module.exports = {
      id: "arrow-right-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }